$(document).ready(function () {
    $("body").lightGallery({
        download: false,
        counter: false,
        selector: ".gallery-item",
        thumbnail: false,
        exThumbImage: "data-exthumbimage",
        autoplayControls: false,
        fullScreen: false,
        zoom: false,
        share: false,
    });
});

// button hover blob
document.querySelectorAll(".liquid-btn").forEach((btn) => {
    const goo = btn.closest(".liquid-btn-goo");
    let resetTimer = null;

    const activate = () => {
        goo.classList.add("is-active");
        clearTimeout(resetTimer);

        // Reset after 3 seconds of no hover
        resetTimer = setTimeout(() => {
            goo.classList.remove("is-active");
        }, 3000);
    };

    const resetOnScroll = () => {
        clearTimeout(resetTimer);
        goo.classList.remove("is-active");
    };

    btn.addEventListener("mouseenter", activate);
    window.addEventListener("scroll", resetOnScroll, { passive: true });
});
